'use client';

import { useState } from 'react';
import { Sidebar } from './components/layout/Sidebar';
import { Header } from './components/layout/Header';
import { Dashboard } from './components/modules/Dashboard';
import { JobAnalysis } from './components/modules/JobAnalysis';
import { JobEvaluation } from './components/modules/JobEvaluation';
import { SalaryDesign } from './components/modules/SalaryDesign';
import { PerformanceManagement } from './components/modules/PerformanceManagement';
import { HRIntegration } from './components/modules/HRIntegration';
import { Reports } from './components/modules/Reports';

export default function JobAnalysisDemo() {
  const [activeModule, setActiveModule] = useState('dashboard');
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const renderContent = () => {
    switch (activeModule) {
      case 'dashboard':
        return <Dashboard onNavigate={handleModuleChange} />;
      case 'job-analysis':
        return <JobAnalysis />;
      case 'job-evaluation':
        return <JobEvaluation />;
      case 'salary-design':
        return <SalaryDesign />;
      case 'performance':
        return <PerformanceManagement />;
      case 'hr-integration':
        return <HRIntegration />;
      case 'reports':
        return <Reports />;
      default:
        return <Dashboard />;
    }
  };

  const handleModuleChange = (module: string) => {
    setActiveModule(module);
    setSidebarOpen(false);
  };

  return (
    <div className="min-h-screen flex w-full bg-background">
      {/* 모바일 오버레이 */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-black/50 z-40 lg:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}
      <Sidebar
        activeModule={activeModule}
        setActiveModule={handleModuleChange}
        isOpen={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
      />
      <div className="flex-1 flex flex-col min-w-0">
        <Header onToggleSidebar={() => setSidebarOpen(!sidebarOpen)} />
        <main className="flex-1 bg-muted/30 overflow-auto">
          {renderContent()}
        </main>
      </div>
    </div>
  );
}
